'use client';

import { ReactNode } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import { tw } from '../../utils';

interface TooltipProps {
  children: ReactNode;
  content: string | ReactNode;
  anchorName: string;
  theme?: 'primary' | 'secondary';
  delay?: number;
  hideArrow?: boolean;
  placement?:
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'left'
    | 'left-start'
    | 'left-end';
}

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  anchorName,
  theme = 'primary',
  delay = 300,
  hideArrow = false,
  placement = 'top',
}: TooltipProps) => {
  return (
    <>
      <div id={anchorName}>{children}</div>
      <ReactTooltip
        anchorSelect={`#${anchorName}`}
        place={placement}
        delayShow={delay}
        opacity={1}
        classNameArrow={tw(hideArrow ? 'hidden' : '!rounded-md')}
        className={tw(
          '!font-kumbh !rounded-lg !px-3 !py-[7px] !text-xs md:!text-sm',
          theme === 'primary'
            ? '!bg-[#3D3D3D] text-white'
            : '!bg-[#242424]/90 text-white',
        )}
      >
        <div className='max-w-[200px]'>{content}</div>
      </ReactTooltip>
    </>
  );
};
